import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IOneCompanySubscriptionPayload } from '@app-store/slices/companySubscriptions/one'

interface TaskAction extends Action {
    payload: IOneCompanySubscriptionPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.companySubscriptions.one

function* oneCompanySubscriptionSagaTask({ payload }: TaskAction) {
    try {
        const params = yield getParams(payload)

        const response = yield axios.get(`/subscriptions/company-subscriptions/${payload.subscriptionId}`, {
            params
        })

        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneCompanySubscriptionSagaTask)
}

export default oneSaga
